import { instructionApis } from '@apis/instructionApis';
import { useQuery } from '@hooks/useQuery';

export const useInstructionOverview = () => {
  return useQuery([`/instruction/overview/`], () =>
    instructionApis.get('/instruction/overview/', {}).then((r) => r[200]!),
  );
};
